// jQuery Helper
import './scripts/jqueryLib.js';

// Internal Files
import handleReturnToTop from './scripts/returnToTop';
import addDataAttributeToCTACard from './scripts/addDataAttributeToCTACard.js';
import trackAccordionExpand from './scripts/trackAccordionExpand.js';

document.addEventListener('DOMContentLoaded', function () {
    handleReturnToTop();
    addDataAttributeToCTACard();
    trackAccordionExpand();
});